import React from 'react';
import { motion } from 'framer-motion';
import { PlanSelector } from './PlanSelector';
export function FinalCTA() {
  return <section className="py-16 md:py-20 bg-navy-950 text-white relative overflow-hidden" data-id="element-195">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-success/10 rounded-full blur-3xl pointer-events-none" data-id="element-196"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-197">
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-198">
          <h2 className="text-3xl md:text-5xl font-black mb-4 leading-tight" data-id="element-199">
            DEJÁ DE MANEJAR TU NEGOCIO A CIEGAS
          </h2>

          <p className="text-base md:text-lg text-slate-300 mb-6 max-w-2xl mx-auto" data-id="element-200">
            Cada día que pasa sin controlar tus finanzas es un día más tomando
            decisiones sin información.
          </p>

          <div className="inline-block bg-navy-800 border border-navy-700 text-white px-4 py-2 rounded-full font-medium text-sm" data-id="element-201">
            🔥 Oferta de lanzamiento — Acceso inmediato
          </div>
        </motion.div>

        <PlanSelector variant="dark" ctaLabel="QUIERO REINICIAR MIS FINANZAS" data-id="element-202" />

        <p className="mt-6 text-center text-slate-400 font-bold tracking-widest uppercase text-sm" data-id="element-203">
          EMPEZÁ HOY MISMO
        </p>
      </div>
    </section>;
}